/**
 * Devuelve la cadena eliminando todos los caracteres html, menos los elementos html de la whitelist
 * @param {string} text
 * @param {array} whiteListElementsHtml  example: ["i", "b"]
 */
export function decodeHtmlWithWhiteList(str, whiteListElementsHtml = []) {
  let r = Math.random().toString(36).substring(7) + new Date().getTime() + Math.random().toString(36).substring(7);

  let html;
  for (let tag of whiteListElementsHtml) {
    str = str.replace(new RegExp(`<${tag}`, 'gi'), `${r}${tag}${r}`);
    str = str.replace(new RegExp(`</${tag}>`, 'gi'), `${r}/${tag}${r}`);
  }
  html = str;
  var tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  html = tmp.textContent || tmp.innerText;
  for (let tag of whiteListElementsHtml) {
    html = html.replace(new RegExp(`${r}${tag}${r}`, 'gi'), `<${tag}`);
    html = html.replace(new RegExp(`${r}/${tag}${r}`, 'gi'), `</${tag}>`);
  }

  return html;
}

export function removeEmptyTags(html) {
  let text = '';
  if (html) {
    text = html.replace(/<strong>\s*<\/strong>/g, '').replace(/<span[^>]*>\s*<\/span>/g, '');
  }
  // Usamos una expresión regular para buscar y eliminar las etiquetas <strong> y <span> vacías
  return text;
}

export function stripHtml(html) {
  if (!html) return '';

  // Primero decodificamos los caracteres especiales
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  const decodedHtml = txt.value;

  // Luego eliminamos las etiquetas HTML
  return decodedHtml.replace(/<[^>]*>/g, '');
}

/**
 * Escapes a value for RFC 4180 compliant CSV format
 * @param {*} value - The value to escape
 * @returns {string} The escaped CSV value
 */
export function escapeCsvValue(value) {
  if (value === null || value === undefined) return '';
  let str = String(value);
  const needsEscaping = str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r') || str.startsWith(' ') || str.endsWith(' ');
  if (!needsEscaping) return str;
  str = str.replace(/"/g, '""');
  return `"${str}"`;
}

/**
 * Escapes a header for CSV export by stripping HTML and applying CSV escaping
 * @param {string} header - The header value (may contain HTML)
 * @returns {string} The escaped CSV header
 */
export function escapeCsvHeader(header) {
  if (!header) return '';
  const cleanHeader = stripHtml(header);
  return escapeCsvValue(cleanHeader);
}
